import React from 'react'

import { MinimalButton } from '@bikemap/components'
import { gettext } from '@bikemap/js/services'

const t = {
    ACTIVE_FILTERS: gettext('Active filters'),
    NUM_FILTERS: gettext('{num} active filters'),
    ONE_FILTER: gettext('1 active filter'),
}

/**
 * Read-only preview of the adapted filters with a reset button.
 * @param {Object} props
 * @param {string[]} props.adaptedFilterNames Names of filters that differ from the default
 * @param {() => void} props.onReset Handler for reset filters button
 * @param {(e: React.MouseEvent) => void} props.onClick Called when user clicks on filter names
 * @param {string} [props.className]
 */
const FiltersPreview = ({ adaptedFilterNames, onReset, onClick, className }) => (
    <div className={'filters-preview text-center text-secondary' + (className ? ' ' + className : '')}>
        <span className="hidden-xs hidden-sm hidden-md">
            {t.ACTIVE_FILTERS + ': '}
            <MinimalButton align onClick={onClick}>
                {adaptedFilterNames.join(', ')}
            </MinimalButton>
        </span>
        <MinimalButton className="hidden-lg hidden-xl" align onClick={onClick}>
            {adaptedFilterNames.length === 1 ? t.ONE_FILTER : (
                t.NUM_FILTERS.replace('{num}', '' + adaptedFilterNames.length)
            )}
        </MinimalButton>
        <MinimalButton className="reset-button" type="reset" icon="i-cancel" variant="text" onClick={onReset}
            data-testid="reset" />
    </div>
)

export default FiltersPreview
